export const FORMATS = ['xlsx', 'csv', 'xml', 'json'] as const;
export type DownloadFormat = (typeof FORMATS)[number];
